<form name="loanPaymentForm" novalidate>
  <div class="domp-to-section">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="domp-form-label-review" translate="domesticPayment.fromAccountSelectLabel"></label>
          <label class="d-block domp-form-label-resume">{{vm.paymentResponse.fromAccountNumber}}</label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6">
              <label class="domp-form-label-review" translate="domesticPayment.amountInputLabel">Amount</label>
            <label class="d-block domp-form-label-resume">
              {{vm.paymentResponse.amount | currency:""}}
              {{vm.paymentResponse.currencySymbol}}
            </label>
          </div>
          <!--<div class="col-sm-6">-->
            <!--<label class="domp-form-label-review" translate="domesticPayment.bankCharges">Bank charges</label>-->
              <!--<a ng-href="{{vm.bankCharges}}" target="_blank" translate="domesticPayment.checkBankCharges" class="domp-form-label-resume">Check the bank charges</a>-->
          <!--</div>-->
        </div>
        <div class="row">
          <div class="col-sm-12 p-t-10">
            <label class="domp-form-label-review" translate="loanPayment.when">When</label>
            <label class="d-block domp-form-label-resume">{{vm.paymentResponse.dueDate | date: 'shortDate' : '+0200'}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="domp-to-section m-t-10">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="domp-form-label-review" translate="payments.toAccount">To account</label>
          <label class="d-block domp-form-label-resume">{{vm.paymentResponse.toAccountNumber }}</label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="domp-form-label-review"  translate="loanPayment.referenceNumber">Reference number</label>
          <label class="d-block domp-form-label-resume">
            {{vm.tempLoanObj.receiverNumberCountryCode}} {{vm.tempLoanObj.receiverNumber1}} {{vm.tempLoanObj.receiverNumber2}}
          </label>
        </div>
      </div>
    </div>
    <!--<div class="row">
     <div class="col-sm-6"></div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="exchange-resume-label"  translate="loanPayment.exchangeRate">Exchange rate</label>
          <label class="d-block exchange-resume-val">no info</label>
        </div>
      </div>
    </div>-->
  </div>

  <!-- SMS auth -->
<!--  <div class="domp-to-section m-t-10">
    <div class="row">
      <div class="col-sm-6 col-xs-12" ng-if="vm.smsAuthentificate != true">
        <div class="form-group">
          <label class="exchange-resume-label" translate="currencyConversion.smsAuthentification"></label>
          <button class="btn btn-default confirm-btn d-block" translate="currencyConversion.sendSms"
                  data-ng-click="vm.showSMSAuthentification();"></button>
        </div>
      </div>
      <div class="col-sm-6 col-xs-12" ng-if="vm.smsAuthentificate == true">
        <div class="form-group">
          <div class="input-group">
            <input type="text" class="form-control input-field"
                   data-ng-model="vm.smsPasswordInput"
                   placeholder="{{'currencyConversion.smsPassword' | translate}}">
          <span class="input-group-btn">
            <button class="btn btn-default input-group-app-btn domp-btn-height">
              <i class="zmdi zmdi-lock"></i>
            </button>
          </span>
          </div>
        </div>
      </div>
    </div>
  </div>-->

  <div class="m-t-10">
    <div class="row">
      <div class="col-xs-12 col-sm-9 hidden-xs">
        <button class="btn btn-primary " translate="currencyConversion.back"
                ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl'"
                data-ng-click="vm.backToLoanPayment();">
        </button>
        <button ng-if="vm.countryCode != 'sl'" class="btn btn-primary" translate="payments.edit"
                data-ng-click="vm.editPayment();">
        </button>
        <button ng-if="vm.countryCode === 'sl'" class="btn btn-primary" translate="domesticPayment.back"
                data-ng-click="vm.editPayment();">
        </button>
        <button ng-if="vm.countryCode != 'sl'" class="btn btn-primary-warning" translate="payments.delete"
                data-ng-click="vm.deletePayment();">
        </button>
      </div>

      <div class="col-xs-12 col-sm-9 visible-xs">
        <button ng-if="vm.countryCode != 'sl'" class="btn btn-default col-xs-12 m-b-5"
                translate="currencyConversion.sign"
                data-ui-sref="payments.sign({payment: vm.paymentResponse, paymentId: vm.paymentResponse.id, type: 'loan'})">
        </button>
        <button ng-if="vm.countryCode === 'sl'" class="btn btn-default col-xs-12 m-b-5"
                translate="currencyConversion.sign"
                ng-disabled="vm.confirmButtonPressed"
                ng-click="vm.sign()">

        </button>

        <button class="btn btn-primary col-xs-12 m-b-5" translate="currencyConversion.back"
                ng-if="APP_GLOBAL_SETTINGS.defaultData.APILocation != 'sl'"
                data-ng-click="vm.backToLoanPayment();">
        </button>
        <button ng-if="vm.countryCode != 'sl'" class="btn btn-primary col-xs-6 " translate="payments.edit"
                data-ng-click="vm.editPayment();">
        </button>
        <button ng-if="vm.countryCode === 'sl'" class="btn btn-primary col-xs-6 " translate="domesticPayment.back"
                data-ng-click="vm.editPayment();">
        </button>
        <button ng-if="vm.countryCode != 'sl'" class="btn btn-primary-warning col-xs-6 " translate="payments.delete"
                data-ng-click="vm.deletePayment();">
        </button>
      </div>

      <div class="col-xs-6 col-sm-3 col-xs-6 hidden-xs">
        <div class="pull-right">
<!--          <button class="btn btn-default confirm-btn"
                  translate="currencyConversion.sign"
                  ng-disabled="!loanPaymentForm.$dirty && vm.smsAuthentificate == false"
                  data-ng-click="vm.signPayment();">
          </button>-->
          <button ng-if="vm.countryCode != 'sl'" class="btn btn-default"
                  translate="currencyConversion.sign"
                  data-ui-sref="payments.sign({payment: vm.paymentResponse, paymentId: vm.paymentResponse.id, type: 'loan'})">
          </button>
          <button ng-if="vm.countryCode === 'sl'" class="btn btn-default"
                  ng-switch="APP_GLOBAL_SETTINGS.defaultData.APILocation"
                  ng-disabled="vm.confirmButtonPressed"
                  ng-click="vm.sign()">
            <span ng-switch-when="sl" translate="domesticPayment.confirmBtn"></span>
            <span ng-switch-default translate="currencyConversion.sign"></span>
          </button>
        </div>

      </div>
    </div>
  </div>

</form>

